import { JOINT_DEFINITIONS } from './JointAngles';
import type { SkeletonDefinition } from './PoseEngine';
import { POSE_LINKS, POSE_NODE_NAMES } from '../skeleton';

export const MEDIAPIPE_SKELETON: SkeletonDefinition = {
  nodeNames: POSE_NODE_NAMES,
  links: POSE_LINKS,
  jointDefs: JOINT_DEFINITIONS,
};
